
export class LoginModel{    
    constructor(public password: string ='', public email: string= '', public accessToken: string= '', public name: string =''){        
        this.email = email;
        this.accessToken = accessToken;
        this.password = password;
        this.name = name;
    }
}